// content.js
// Fetches editable content from the backend SQLite-backed content API.
// Components call `fetchContent(key)` or `useContent(keys)` to get dynamic
// text instead of hardcoded strings.

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "http://localhost:8001").replace(/\/$/, "") + "/api";

const CACHE_KEY = "site_content_cache";
const CACHE_TTL_MS = 5 * 60 * 1000;

let contentCache = {};
let cacheTimestamp = 0;

async function loadAllContent(force = false) {
    const now = Date.now();
    if (!force && contentCache && Object.keys(contentCache).length && now - cacheTimestamp < CACHE_TTL_MS) {
        return contentCache;
    }
    try {
        const res = await fetch(`${API_BASE}/content`, { cache: "no-store" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const items = await res.json();
        contentCache = items.reduce((acc, item) => {
            acc[item.key] = item.value;
            return acc;
        }, {});
        cacheTimestamp = now;
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ data: contentCache, ts: cacheTimestamp })); } catch {}
        return contentCache;
    } catch (e) {
        console.warn("[content] failed to load from API, trying localStorage cache:", e);
        try {
            const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "{}");
            if (cached.data) return cached.data;
        } catch {}
        return {};
    }
}

export async function fetchContent(key, fallback = "") {
    const all = await loadAllContent();
    return all[key] || fallback;
}

export async function fetchContentObject(keys = {}, fallbacks = {}) {
    const all = await loadAllContent();
    const result = {};
    for (const key of Object.keys(keys)) {
        result[key] = all[key] || fallbacks[key] || "";
    }
    return result;
}

export async function refreshContent() {
    cacheTimestamp = 0;
    contentCache = {};
    try { localStorage.removeItem(CACHE_KEY); } catch {}
    return loadAllContent(true);
}
